import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { Calendar, Clock, ArrowLeft, ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import { getPost, BLOG } from "@/data/site";
import { Reveal } from "@/components/Reveal";
import { useLead } from "@/context/LeadContext";

export default function BlogPost() {
  const { slug } = useParams();
  const post = getPost(slug);
  const { openLead } = useLead();
  if (!post) return <Navigate to="/blog" replace />;
  const more = BLOG.filter((b) => b.slug !== slug).slice(0, 3);

  return (
    <div data-testid="blog-post-page">
      <PageHero title={post.title} image={post.image} crumbs={[{ label: "Blog", to: "/blog" }, { label: post.tag }]} />

      <article className="bg-white py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-5 md:px-8">
          <div className="flex items-center gap-4 text-sm text-slate-500 mb-8 pb-8 border-b border-slate-200">
            <span className="text-royal font-semibold bg-royal/10 px-3 py-1 rounded-full">{post.tag}</span>
            <span className="flex items-center gap-1"><Calendar className="h-4 w-4" />{post.date}</span>
            <span className="flex items-center gap-1"><Clock className="h-4 w-4" />{post.read}</span>
          </div>

          <p className="text-xl text-navy-deep font-medium leading-relaxed mb-6">{post.excerpt}</p>
          <p className="text-slate-600 leading-relaxed text-lg">{post.body}</p>
          <p className="text-slate-600 leading-relaxed text-lg mt-4">
            At JAL RAKSHAKK, every project starts with a free inspection and root-cause diagnosis. Whether you're in Vaishali Nagar, Mansarovar, Malviya Nagar or anywhere across Jaipur, our engineers recommend the right system and back it with up to 15-year warranty.
          </p>

          <div className="bg-navy-deep rounded-lg p-8 mt-10 text-white text-center">
            <h3 className="font-display text-2xl font-extrabold">Facing a similar problem?</h3>
            <p className="text-slate-300 mt-2">Book a free inspection and get a transparent quote today.</p>
            <button onClick={() => openLead("book_inspection")} className="btn-ripple mt-5 bg-royal hover:bg-royal/90 text-white font-semibold px-6 py-3 rounded-sm transition-colors inline-flex items-center gap-2" data-testid="blogpost-book">
              Book Free Inspection <ArrowRight className="h-4 w-4" />
            </button>
          </div>

          <Link to="/blog" className="inline-flex items-center gap-2 text-royal font-semibold mt-10"><ArrowLeft className="h-4 w-4" /> Back to all articles</Link>
        </div>
      </article>

      <section className="bg-soft-grey py-16">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <h2 className="font-display text-2xl font-extrabold text-navy-deep mb-8">More Articles</h2>
          <div className="grid md:grid-cols-3 gap-6">
            {more.map((p) => (
              <Link key={p.slug} to={`/blog/${p.slug}`} className="group block bg-white rounded-lg overflow-hidden border border-slate-200 hover:-translate-y-1 hover:shadow-lg transition-all">
                <div className="h-40 overflow-hidden"><img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" /></div>
                <div className="p-5"><h3 className="font-display font-bold text-navy-deep group-hover:text-royal transition-colors">{p.title}</h3></div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
